import { readOroborosSessionSnapshot } from '../oroboros/sessionCache';
import { isLiveSessionAccessToken } from '../utils/sessionAccessToken';

/** Visible refresh/session cookies that indicate an Artifice Account on this device. */
const ARTIFICE_SESSION_COOKIE_MARKERS = [
  'terminal_refresh=',
  'artifice_refresh=',
  'terminal_auth_token=',
  'artifice_auth_token=',
] as const;

export type CachedSessionPeek = {
  signedIn: boolean;
};

export function peekCachedSession(): CachedSessionPeek | null {
  const snap = readOroborosSessionSnapshot();
  if (snap?.user?.userId) return { signedIn: true };
  return null;
}

export function hasArtificeSessionMarker(cookieHeader?: string): boolean {
  if (isLiveSessionAccessToken()) return true;
  const raw =
    cookieHeader ??
    (typeof document !== 'undefined' ? String(document.cookie || '') : '');
  if (!raw) return false;
  return ARTIFICE_SESSION_COOKIE_MARKERS.some((needle) => raw.includes(needle));
}

/**
 * Terminal LOCK: offer “Continue with Artifice Account” only when a real session
 * marker exists — remembered username alone does not qualify.
 */
export function canOfferArtificeContinue(signedIn: boolean): boolean {
  if (signedIn) return true;
  if (peekCachedSession()?.signedIn) return true;
  if (hasArtificeSessionMarker()) return true;
  return false;
}

export type LoginChooserAction = 'continue' | 'login';

/** Stable chooser actions for tests and LoginChooser. */
export function loginChooserActions(canContinue: boolean): LoginChooserAction[] {
  const actions: LoginChooserAction[] = [];
  if (canContinue) actions.push('continue');
  actions.push('login');
  return actions;
}
